import { render, staticRenderFns } from "./salesRecord.vue?vue&type=template&id=756f6be1&scoped=true"
import script from "./salesRecord.vue?vue&type=script&lang=js"
export * from "./salesRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f6be1",
  null
  
)

export default component.exports